import React from 'react'
import { Typography, Link, Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from '../styles'

const SectionHeader = ({ classes, title, link, linkText }) => {
  return (
    <Box className={classes.sectionHeader}>
      <Typography className={classes.sectionTitle}>{title}</Typography>
      <Link href={link} className={classes.allLink}>
        {linkText}
      </Link>
    </Box>
  )
}

export default withStyles(styles)(SectionHeader)
